import { useEffect } from "react";
import { useHeaderStore } from "../store/useHeader";

const useHeader = (options: { header: string , subheader?: string } | undefined) => {
  const setHeaderTitle = useHeaderStore(state => state.setHeaderTitle)
  const setHeaderSubtitle = useHeaderStore(state => state.setHeaderSubtitle)
  const headerTitle = useHeaderStore(state => state.title)
  const subTitle = useHeaderStore(state => state.subTitle)

  useEffect(()=> {
    if(options?.header) setHeaderTitle(options.header)
    if(options?.subheader) setHeaderSubtitle(options.subheader)
  },[options?.header, options?.subheader, setHeaderSubtitle, setHeaderTitle])

  return {
    header: headerTitle,
    subheader: subTitle,
  }
}


export default useHeader;